export default {
  "freeSpinConfig.title": "免费旋转配置",
  "freeSpinConfig.column.no": "#序号",
  "freeSpinConfig.column.freeSpinBonusId": "免费旋转奖励ID",
  "freeSpinConfig.column.gameId": "游戏ID",
  "freeSpinConfig.column.betAmount": "投注金额",
  "freeSpinConfig.column.rounds": "轮次",
  "freeSpinConfig.column.jumpUrl": "跳转链接",
  "freeSpinConfig.column.chanceType": "机会类型",
  "freeSpinConfig.column.startTime": "开始时间",
  "freeSpinConfig.column.endTime": "结束时间",
  "freeSpinConfig.column.action": "操作",
  "freeSpinConfig.action.delete": "删除",
  "freeSpinConfig.action.add": "新增",
  "freeSpinConfig.action.edit": "编辑",
  "freeSpinConfig.form.gameId": "游戏ID",
  "freeSpinConfig.form.betAmount": "投注金额",
  "freeSpinConfig.form.rounds": "轮次",
  "freeSpinConfig.form.withdrawLimit": "提现限制",
  "freeSpinConfig.form.startTime": "开始时间",
  "freeSpinConfig.form.endTime": "结束时间",
  "freeSpinConfig.form.jumpUrl": "跳转链接",
  "freeSpinConfig.form.chanceType": "机会类型",
  "freeSpinConfig.confirm.delete.title": "删除免费旋转: {freeSpinBonusId}",
  "freeSpinConfig.confirm.delete.content": "确定要删除此免费旋转吗？",
  "freeSpinConfig.confirm.ok": "确认",
  "freeSpinConfig.confirm.cancel": "取消",
  "freeSpinConfig.add": "新增",
  "freeSpinConfig.edit": "编辑",
};